import cl from "clsx";
import React, { forwardRef } from "react";
import { Slot } from "../../slot/Slot.js";
import { createContext } from "../../util/create-context.js";
const [ThemeProvider, useAkselTheme] = createContext({
    errorMessage: "useAkselTheme must be used within AkselThemeProvider",
    hookName: "useAkselTheme",
    name: "AkselThemeProvider",
    providerName: "AkselThemeProvider",
});
const AkselTheme = forwardRef((props, ref) => {
    var _a, _b;
    const context = useAkselTheme(false);
    const { children, className, asChild = false, theme = (_a = context === null || context === void 0 ? void 0 : context.theme) !== null && _a !== void 0 ? _a : "light", volume = (_b = context === null || context === void 0 ? void 0 : context.volume) !== null && _b !== void 0 ? _b : "low", hasBackground: hasBackgroundProp = true, } = props;
    const isRoot = context === undefined;
    const hasBackground = hasBackgroundProp !== null && hasBackgroundProp !== void 0 ? hasBackgroundProp : (isRoot || props.theme !== undefined);
    const SlotElement = asChild ? Slot : "div";
    return (React.createElement(ThemeProvider, { theme: theme, volume: volume },
        React.createElement(SlotElement, { ref: ref, className: cl("navds-theme", className, theme), "data-background": hasBackground, "data-volume": volume }, children)));
});
export { AkselTheme, useAkselTheme };
//# sourceMappingURL=AkselTheme.js.map